import React from "react";
import { FormHelperText, Typography } from "@mui/material";
import { TextField } from "@components/Input/Input.styles";
import { useTranslation } from "react-i18next";
import { usePortServicesFlow } from "../context/PortServicesFlowContext";
import { specialInstructionsOnlySchema } from "../schemas/approveByHSESludgeDisposalSchema";

const LANG_BASE = "vessel-call.port-services";

const SpecialInstructionsField = () => {
  const { t } = useTranslation();
  const { setSpecialInstructions, specialInstructions, errors, setErrors } = usePortServicesFlow();

  const charCounterSx = {
    ml: 0,
    mt: 0.5,
    fontSize: 12,
    textAlign: "right",
    color: "text.secondary",
  };

  const isPrintableKey = (e: React.KeyboardEvent) =>
    e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey;
  const TEXTAREA_MAX_CHARS = 1500;

  return (
    <div className="flex flex-col gap-2" data-testid="port-services-special-instructions">
      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
        {t(`${LANG_BASE}.fields.special-instructions`)}
      </Typography>
      <TextField
        multiline
        minRows={4}
        value={specialInstructions}
        inputProps={{ maxLength: TEXTAREA_MAX_CHARS }}
        placeholder={t(`${LANG_BASE}.fields.special-instructions`)}
        sx={{ "& textarea": { padding: "12px", borderRadius: "8px" } }}
        onKeyDown={(e: React.KeyboardEvent) => {
          if (!isPrintableKey(e)) return;
          if (specialInstructions.length >= TEXTAREA_MAX_CHARS) {
            setErrors({
              ...errors,
              specialInstructions: t("form-validation.max-length", {
                label: t(`${LANG_BASE}.fields.special-instructions`),
                max: TEXTAREA_MAX_CHARS,
              }),
            });
          }
        }}
        onBlur={() => {
          const res = specialInstructionsOnlySchema().safeParse({ specialInstructions });
          if (!res.success) {
            const flat = res.error.flatten().fieldErrors;
            setErrors({ ...errors, specialInstructions: flat.specialInstructions?.[0] });
          } else {
            setErrors({ ...errors, specialInstructions: undefined });
          }
        }}
        onChange={(e) => {
          const val = e.target.value;
          setSpecialInstructions(val);
          const res = specialInstructionsOnlySchema().safeParse({ specialInstructions: val });
          if (!res.success) {
            const flat = res.error.flatten().fieldErrors;
            setErrors({ ...errors, specialInstructions: flat.specialInstructions?.[0] });
          } else {
            setErrors({ ...errors, specialInstructions: undefined });
          }
        }}
      />
      {errors.specialInstructions && (
        <FormHelperText sx={{ color: "error.main", m: 0 }}>
          {errors.specialInstructions}
        </FormHelperText>
      )}
      <FormHelperText sx={charCounterSx}>
        {specialInstructions.length}/{TEXTAREA_MAX_CHARS}
      </FormHelperText>
    </div>
  );
};

export default SpecialInstructionsField;
